import { injectReducer } from 'store/reducers'
import { injectSagas } from 'store/sagas'
import Intro from './routes/Intro'
import Statements from './routes/Statements'
import SwapStatements from './routes/SwapStatements'
import StatementReflection from './routes/StatementReflection'

export default (store) => ({
  path: 'money-tool',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const MoneyTool = require('./containers/MoneyToolContainer').default
      const reducer = require('./modules/reducer').default
      const sagas = require('./modules/sagas').sagas

      /*  Add the reducer to the store on key 'moneyTool'  */
      injectReducer(store, { key: 'moneyTool', reducer })
      injectSagas(store, { key: 'moneyTool', sagas })

      // ensure grid reducer & sagas are initialized for when loadAnswers is called in the MoneyTool componentWillMount
      {
        const reducer = require('containers/Grid/modules/reducer').default
        const sagas = require('containers/Grid/modules/sagas').sagas
        injectReducer(store, {key: 'grid', reducer })
        injectSagas(store, {key: 'grid', sagas })
      }

      /*  Return getComponent   */
      cb(null, MoneyTool)

    /* Webpack named bundle   */
    }, 'MoneyTool')
  },

  indexRoute: { onEnter: (nextState, replace) => replace('/money-tool/intro') },

  childRoutes: [
    Intro(store),
    Statements(store),
    SwapStatements(store),
    StatementReflection(store)
  ]
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/MoneyTool/index.js
 **/